import React from "react"
import { RichTextBlock } from "prismic-reactjs"

import { Text } from "../Text/Text"
import { FaqQuestions } from "./faq-questions/FaqQuestions"


interface OwnProps {
  questions: {
    question: string;
    answer: {
      richText: RichTextBlock,
      text: string
    }
  }[]
}

export type FaqProps = OwnProps

export const Faq: React.FC<FaqProps> = ({
  questions
}) => {
  return (
    <div className="bg-light-wool">
      <div className="max-w-content-width mx-auto px-5 py-8 md:py-16 md:grid md:grid-cols-2 md:gap-32">
        <Text as="span" variant="large-header">Frequently Asked Questions</Text>
        <FaqQuestions questions={questions} />
      </div>
    </div>
  )
}
